import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import { noop } from 'lodash';
import styled from 'styled-components';

import { Dropdown, DropdownContainer } from '@zocdoc/components/src/dropdown';
import { filterToValidAttributes } from '@zocdoc/dom-property';

export const LOCALIZED_STRINGS = defineMessages({
    Label: {
        id: 'Components.RefineSearch.SpecialtiesDropdown.Label',
        defaultMessage: 'specialty: ',
    },
});

const Container = styled.div`
    align-items: center;
    display: flex;
    overflow: hidden;
`;

export const DropdownLabel = styled.div`
    flex-shrink: 0;
    margin-right: 10px;
    white-space: nowrap;
`;

const StyledDropdownContainer = styled(DropdownContainer)`
    flex-basis: auto;
    width: auto;
    color: ${({ theme }) => theme.search.header.filters.textColor};
`;

const StyledDropdown = styled(Dropdown)`
    background: transparent;
    border: 0;
    line-height: 1;
    min-width: 50px;
`;

class SpecialtiesDropdown extends PureComponent {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        onChangeCallback: PropTypes.func.isRequired,
        specialtyId: PropTypes.string.isRequired,
        specialties: PropTypes.array.isRequired,
        trackRefineSearchClickSpecialtiesDropdown: PropTypes.func,
        trackRefineSearchSelectSpecialty: PropTypes.func,
    };

    static defaultProps = {
        trackRefineSearchSelectSpecialty: noop,
    };

    handleChange = update => {
        const specialty = { specialtyId: update };

        this.props.trackRefineSearchSelectSpecialty(specialty);
        this.props.onChangeCallback(specialty);
    }

    render() {
        const {
            intl,
            specialtyId,
            specialties,
            ...props
        } = this.props;

        return (
            <Container
                {...filterToValidAttributes(props)}
                data-test="search-specialties-dropdown-container"
            >
                <DropdownLabel>{intl.formatMessage(LOCALIZED_STRINGS.Label)}</DropdownLabel>

                <StyledDropdownContainer
                    data-test="search-specialties-dropdown-container-inner"
                    onChange={this.handleChange}
                    selected={specialtyId}
                >
                    <StyledDropdown
                        data-test="search-specialties-dropdown"
                        inline
                        onClick={this.props.trackRefineSearchClickSpecialtiesDropdown}
                        options={specialties}
                        placeholder="choose a specialty"
                    />
                </StyledDropdownContainer>
            </Container>
        );
    }
}

export default injectIntl(SpecialtiesDropdown);
